import { Award, CheckCircle2, Users, Briefcase } from "lucide-react";
import { Button } from "@/components/ui/button";

const creds = [
  "13+ years of Automation Testing experience at top Indian IT companies.",
  "Trained 2000+ students with a 4.9 ★ rating across verified UrbanPro reviews",
  "Selenium WebDriver, Java, Cucumber BDD, Playwrights, Jenkins, Appium — all in one curriculum",
  "UrbanPro Certified Tutor for Automation Testing · Pune · Live online via Zoom",
];

export default function Authority({ onCtaClick }) {
  return (
    <section id="coach" className="relative py-20 md:py-32 px-6 md:px-10" data-testid="authority-section">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Portrait */}
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] max-w-md mx-auto lg:mx-0">
            <div className="absolute -inset-3 bg-[#38BDF8]/20 blur-2xl rounded-3xl" />
            <div className="absolute inset-0 rounded-3xl overflow-hidden border border-slate-800">
              <img
                src="https://customer-assets.emergentagent.com/job_blissful-saha-5/artifacts/lzyc1h0j_Gemini_Rahul_1.png"
                alt="Rahul Ganjare"
                className="w-full h-full object-cover"
                data-testid="coach-portrait"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent" />
            </div>
            <div className="absolute bottom-5 left-5 right-5 bg-[#0A1628]/80 backdrop-blur-md border border-white/10 rounded-2xl p-4">
              <div className="text-xs text-[#38BDF8] font-semibold tracking-widest uppercase">
                Your Mentor
              </div>
              <div className="font-display text-xl font-normal text-white mt-1">
                Rahul Ganjare
              </div>
              <div className="text-xs text-slate-400 mt-1">
                Automation Testing Expert
              </div>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-3 mt-6 max-w-md mx-auto lg:mx-0">
            {[
              { icon: Users, label: "2000+", sub: "Students" },
              { icon: Briefcase, label: "18Y+", sub: "IT Industry" },
              { icon: Award, label: "4.9★", sub: "Verified Reviews" },
            ].map((s, i) => (
              <div
                key={i}
                className="bg-slate-900/60 border border-slate-800 rounded-xl p-4 text-center"
                data-testid={`coach-stat-${i}`}
              >
                <s.icon className="w-4 h-4 text-[#38BDF8] mx-auto" />
                <div className="font-display font-normal text-white mt-2">{s.label}</div>
                <div className="text-[10px] text-slate-500 uppercase tracking-widest">
                  {s.sub}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Copy */}
        <div className="lg:col-span-7">
          <div className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#38BDF8]">
            Meet Your Coach
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-normal text-white mt-4 leading-tight">
            Rahul doesn't teach theory.
            <br />
            <span className="text-[#38BDF8]">He's lived your struggle.</span>
          </h2>
          <p className="mt-6 text-lg text-slate-400 leading-relaxed">
            Rahul Ganjare is an UrbanPro-certified Automation Testing trainer based in
            Pune, Lohgaon — with over a decade in the industry and 2000+ students
            already trained live on Zoom. His students rate him
            <span className="text-white font-medium"> 4.9 out of 5 </span>
            across verified reviews. He teaches automation the
            <span className="text-[#38BDF8] font-semibold"> shortcut way </span>
            — no coding background needed.
          </p>

          <ul className="mt-8 space-y-4">
            {creds.map((c, i) => (
              <li
                key={i}
                className="flex gap-3 items-start"
                data-testid={`coach-credential-${i}`}
              >
                <CheckCircle2 className="w-5 h-5 text-[#38BDF8] flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 leading-relaxed">{c}</span>
              </li>
            ))}
          </ul>

          <Button
            onClick={onCtaClick}
            className="btn-yellow font-bold uppercase tracking-wider text-sm h-13 px-7 rounded-full mt-10"
            data-testid="authority-cta-button"
          >
            Book My Seat @99/- Only
          </Button>
        </div>
      </div>
    </section>
  );
}
